import { Box, Button, InputBase, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from "react";
import { useUpdateDeliverySettings } from "../globalFunctions";
import { useSelector } from "react-redux";
import Divider from '@mui/material/Divider';
import CustomAxios from "../../utils/CustomAxios";
import useStatusToggle from "../../hooks/useStatusToggle";
import StatusSwitch from "../../sub_components/status_switch";
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export function GeneralSettings() {
    const [switchStates, setSwitchStates] = useState({});
    const statusToggle = useStatusToggle();
    const getdeliverySettings = useUpdateDeliverySettings()
    const settings = useSelector(state => state.settings.settings);
    const [selectedTime, setSelectedTime] = useState(dayjs());
    const [isElementEnabled, setIsElementEnabled] = useState(false);
    const handleTimeChange = (newTime) => {
        setSelectedTime(newTime);
    };
    useEffect(() => {
        getdeliverySettings()
    }, [])

    useEffect(() => {
        if (settings?.length > 0) {
            const initialStates = {};
            settings.forEach((item) => {
                initialStates[item.order_pickup_mode] = item.status;
                console.log(item.delivery_opens_at)
                if (item.delivery_opens_at) {
                    const deliveryTime = dayjs(item.delivery_opens_at); // Convert API time to dayjs object
                    const currentTime = dayjs(); 
                
                    if (deliveryTime.isBefore(currentTime)&&item.status==true) {
                        console.log("we are inside here",deliveryTime.isBefore(currentTime),deliveryTime,currentTime)
                        item.order_pickup_mode=='Online Delivery'&&setSelectedTime(currentTime); 
                    } else {
                        item.order_pickup_mode=='Online Delivery'&&setSelectedTime(deliveryTime); 
                    }
                }
            });
            setSwitchStates(initialStates);
        }
    }, [settings]);

    const handleChange = async (event, item) => {
        const newValue = event.target.checked;
        let updatedTime = selectedTime; 
        if (newValue === true) {
            updatedTime = dayjs(); 
            setSelectedTime(updatedTime);
        }
        const time = item.order_pickup_mode === "Online Delivery" ? updatedTime : selectedTime;

        await statusToggle.run(item.id, newValue, async () => {
            try {
                await CustomAxios.post("update_delivery_availability/", {
                    id: item.id,
                    status: newValue,
                    time: time.toISOString()
                });
            } catch (error) {
                console.error("Failed to update delivery settings", error);
                throw error;
            }
            await getdeliverySettings();
        });
    };
    useEffect(() => {
        const now = dayjs(); 
        console.log(now)
        const selectedHour = selectedTime.hour();
        const selectedMinute = selectedTime.minute();
        const currentHour = now.hour();
        const currentMinute = now.minute();
    
        // Enable the element only if selected time (HH:mm) is in the future
        const isFutureTime =
            selectedHour > currentHour ||
            (selectedHour === currentHour && selectedMinute > currentMinute);
    
        setIsElementEnabled(isFutureTime);
    }, [selectedTime]);

  
    console.log(selectedTime)
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%", padding: "30px" }}>
            {/* <Toast ref={toast} /> */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Settings</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>General settings</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Box sx={{ position: "relative" }}>
                    <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "268px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Search settings" />
                    <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
                </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", width: "100%", background: "#FFF", height: "500px", padding: "20px" }}>
                {settings.map((item) => (
                    <>
                        <Box key={item.order_pickup_mode} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "70px" }}>
                            <Typography>{item.order_pickup_mode}</Typography>
                            <Box sx={{display:"flex",alignItems:"center"}}>
                        {item.order_pickup_mode=='Online Delivery'&&<LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileTimePicker
                                value={selectedTime}
                                onChange={handleTimeChange}
                            />
                        </LocalizationProvider>}
                            <StatusSwitch
                                disabled={item.order_pickup_mode=='Online Delivery'&&item.status==true&&!isElementEnabled}
                                pending={statusToggle.isPending(item.id)}
                                checked={!!statusToggle.displayed(item.id, switchStates[item.order_pickup_mode] || false)}
                                onChange={(e) => handleChange(e, item)}
                                inputProps={{ "aria-label": item.order_pickup_mode }}
                            />
                            </Box>
                        </Box>
                        <Divider />
                    </>

                ))}

            </Box>

        </Box>
    )
}